import { useState } from 'react';
import { IconButton, Tooltip, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExportDownload from 'assets/icons/svg/Export-download.svg?react';

export type ExportType = 'CSV' | 'EXCEL' | 'XML' | 'JSON';

interface ExportDropdownProps {
  tooltip?: string;
  onDownload: (type: ExportType) => void;
  disabled?: boolean;
}

const ExportDropdown = ({ tooltip, onDownload, disabled }: ExportDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation(); // ⛔ prevent ActionButtons click
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadClick = (type: ExportType) => {
    handleClose();
    onDownload(type);
  };

  return (
    <>
      <Tooltip title={tooltip} placement="top" arrow>
        <IconButton
          disabled={disabled}
          onClick={handleOpen}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '2px'
          }}
        >
          <ExportDownload />
          {/* <ArrowDropDownIcon sx={{ fontSize: 16, color: '#000' }} /> */}
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem disabled>Downloaded At</MenuItem>
        <MenuItem onClick={() => handleDownloadClick('CSV')}>CSV</MenuItem>
        <MenuItem onClick={() => handleDownloadClick('EXCEL')}>EXCEL</MenuItem>
        <MenuItem onClick={() => handleDownloadClick('XML')}>XML</MenuItem>
        <MenuItem onClick={() => handleDownloadClick('JSON')}>JSON</MenuItem>
      </Menu>
    </>
  );
};

export default ExportDropdown;
